export interface MenuItem {
  name: string
  url: string
  children?: MenuItem[]
}

/** 主菜单 */
const menu: MenuItem[] = [
  {
    name: '作品',
    url: '/works',
  },
  {
    name: '游戏',
    url: '/game',
  },
  {
    name: '联系我们',
    url: '/blog',
      children: [
        {
            name: '公众号',
            url: 'https://image-static.segmentfault.com/170/672/1706722225-666d5d93e0e9d_fix732',
        },
        {
            name: '哔哩哔哩',
            url: 'https://space.bilibili.com/286666708/',
        },
        {
            name: '独立博客',
            url: 'https://www.zerofc.cn/',
        },
        {
            name: 'GitHub',
            url: 'https://github.com/z11r00/',
        },
        {
            name: '微博',
            url: 'https://weibo.com/u/7116254923/',
        },
    ],
  },
]

export default menu
